'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _titleSection = require('./common/title-section');

var _titleSection2 = _interopRequireDefault(_titleSection);

var _bodySection = require('./common/body-section');

var _bodySection2 = _interopRequireDefault(_bodySection);

var _ctaSection = require('./common/cta-section');

var _ctaSection2 = _interopRequireDefault(_ctaSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = _react2['default'].createClass({
    displayName: 'ESign SEO Page',

    renderTitleSection: function renderTitleSection() {
        var titleSectionProps = {
            title: 'eSign Basics',
            subtitle: 'Need to eSign a document? Use HelloSign for free.',
            buttonText: 'SIGN UP'
        };
        return _react2['default'].createElement(_titleSection2['default'], _extends({}, titleSectionProps, this.props));
    },

    renderBodySection: function renderBodySection() {
        var headerClass = 'm-marketing-page--header';
        var listClass = 'm-marketing-page--list';
        return _jsx(_bodySection2['default'], {}, void 0, _jsx('h2', {
            className: headerClass
        }, void 0, 'How do I eSign a document?'), _jsx('p', {}, void 0, 'When you have a document to sign, it can be uploaded to an eSignature service, such as ', _jsx('a', {
            href: '/',
            target: '_blank'
        }, void 0, 'HelloSign'), ', to generate a signature. Once the document is eSigned, you can email the document to your intended recipient. eSignatures are a legally accepted and protected form of signature. In the US, they’re covered by the eSign Act.'), _jsx('h2', {
            className: headerClass
        }, void 0, 'What is the ESIGN Act?'), _jsx('p', {}, void 0, 'The ESIGN Act, otherwise known as Electronic Signatures in Global and National Commerce Act, was signed in 2000 to give eSignatures the same status as written signatures.'), _jsx('p', {}, void 0, 'Learn more about the ESIGN Act by ', _jsx('a', {
            href: 'http://info.hellosign.com/esignatures-cheat-sheet.html',
            target: '_blank'
        }, void 0, 'downloading our free eBook: eSignatures 101'), '.'), _jsx('h2', {
            className: headerClass
        }, void 0, 'What are the benefits of eSigning?'), _jsx('p', {}, void 0, 'Being able to eSign a document is great for improving workflows. When you eSign a document, you eliminate the need to print the document, sign it, then scan it. Being able to eSign documents streamlines the process for completing paperwork and reduces productivity waste.'), _jsx('p', {}, void 0, 'Here are some of the other ways eSignatures are beneficial:'), _jsx('ul', {
            className: listClass
        }, void 0, _jsx('li', {}, void 0, 'Faster turnaround time for completed documents and contracts'), _jsx('li', {}, void 0, 'Better security and document tracking'), _jsx('li', {}, void 0, 'Low cost'), _jsx('li', {}, void 0, 'Eliminate paper waste')), _jsx('h2', {
            className: headerClass
        }, void 0, 'What are the limitations of eSigning?'), _jsx('p', {}, void 0, 'There are certain types of documentation that are not covered by the ESIGN Act (for example, adoption and divorce papers). For a list of documents that need to be signed in-person, you can ready about it in our ', _jsx('a', {
            href: 'http://blog.hellosign.com/esignatures-legal-handwritten-signatures',
            target: '_blank'
        }, void 0, 'blog post on eSignature legality'), '.'), _jsx('h2', {
            className: headerClass
        }, void 0, 'How do I use HelloSign to eSign?'), _jsx('p', {}, void 0, 'Signing a document using HelloSign only takes a few minutes. Here are the steps to eSigning your first document:'), _jsx('ol', {}, void 0, _jsx('li', {}, void 0, 'Create a Hellosign account.'), _jsx('li', {}, void 0, 'Choose who needs to sign (“Just me”, “Me & Others”, or “Just Others”).'), _jsx('li', {}, void 0, 'Upload your document.'), _jsx('li', {}, void 0, 'Sign or add signature fields.'), _jsx('li', {}, void 0, 'Send off your document to the intended recipient.')), _jsx('p', {}, void 0, 'For more detailed instructions, head over to our ', _jsx('a', {
            href: 'https://faq.hellosign.com/hc/en-us/categories/200353538-HelloSign-Help',
            target: '_blank'
        }, void 0, 'Help Center'), ' for information on this and other features.'));
    },

    renderCTASection: function renderCTASection() {
        var ctaSectionProps = {
            title: 'Get started: eSign a document for free',
            subtitle: 'Want to try eSigning yourself? Create a free account with us (no strings attached, we promise!). Or if you’re looking for more features for your business (for example, team features, in-person signing, or signer access codes), request a demo with one of our eSignature experts.',
            signupButtonText: 'CREATE A HELLOSIGN ACCOUNT',
            signupButtonUrl: this.props.homeUrl,
            secondButtonText: 'SEE PRO PLANS',
            secondButtonUrl: this.props.pricingUrl,
            apiUsersHeaderText: 'LOOK WHO\'S USING HELLOSIGN',
            embeddedTweetsHeaderText: 'HAPPY TWEETS FROM HAPPY USERS'
        };
        return _react2['default'].createElement(_ctaSection2['default'], _extends({}, ctaSectionProps, this.props));
    },

    render: function render() {
        return _jsx('div', {}, void 0, this.renderTitleSection(), this.renderBodySection(), this.renderCTASection());
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/esign.jsx
 ** module id = 830
 ** module chunks = 0
 **/